module.exports = __webpack_public_path__ + "static/media/package.503ec98c.png";